/* tslint:disable */
/* eslint-disable */
/**
 * gremiumhub
 * A platform for digital applications, approvals and discussions.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: denis.lugowski@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TableRowPresetDto } from './TableRowPresetDto';
import {
    TableRowPresetDtoFromJSON,
    TableRowPresetDtoFromJSONTyped,
    TableRowPresetDtoToJSON,
    TableRowPresetDtoToJSONTyped,
} from './TableRowPresetDto';
import type { SectionSpawnTriggerDto } from './SectionSpawnTriggerDto';
import {
    SectionSpawnTriggerDtoFromJSON,
    SectionSpawnTriggerDtoFromJSONTyped,
    SectionSpawnTriggerDtoToJSON,
    SectionSpawnTriggerDtoToJSONTyped,
} from './SectionSpawnTriggerDto';
import type { VisibilityConditionGroup } from './VisibilityConditionGroup';
import {
    VisibilityConditionGroupFromJSON,
    VisibilityConditionGroupFromJSONTyped,
    VisibilityConditionGroupToJSON,
    VisibilityConditionGroupToJSONTyped,
} from './VisibilityConditionGroup';
import type { FormElementType } from './FormElementType';
import {
    FormElementTypeFromJSON,
    FormElementTypeFromJSONTyped,
    FormElementTypeToJSON,
    FormElementTypeToJSONTyped,
} from './FormElementType';
import type { FormOptionDto } from './FormOptionDto';
import {
    FormOptionDtoFromJSON,
    FormOptionDtoFromJSONTyped,
    FormOptionDtoToJSON,
    FormOptionDtoToJSONTyped,
} from './FormOptionDto';

/**
 * 
 * @export
 * @interface FormElementDto
 */
export interface FormElementDto {
    /**
     * 
     * @type {string}
     * @memberof FormElementDto
     */
    id?: string | null;
    /**
     * Unique reference key for this form element (e.g., "art_der_massnahme")
     * @type {string}
     * @memberof FormElementDto
     */
    reference?: string;
    /**
     * 
     * @type {string}
     * @memberof FormElementDto
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof FormElementDto
     */
    description?: string;
    /**
     * Legal statement. `{{wert}}` is replaced with the rendered field value.
     * @type {string}
     * @memberof FormElementDto
     */
    statement?: string;
    /**
     * Longer plain-text explanation shown in a popover behind an info icon next to the question title. Line breaks are kept. Not part of document exports.
     * @type {string}
     * @memberof FormElementDto
     */
    clarification?: string;
    /**
     * 
     * @type {Array<FormOptionDto>}
     * @memberof FormElementDto
     */
    options: Array<FormOptionDto>;
    /**
     * 
     * @type {FormElementType}
     * @memberof FormElementDto
     */
    type: FormElementType;
    /**
     * 
     * @type {string}
     * @memberof FormElementDto
     */
    formElementSubSectionId?: string | null;
    /**
     * Recursive visibility condition tree (AND/OR groups with leaf conditions)
     * @type {VisibilityConditionGroup}
     * @memberof FormElementDto
     */
    visibilityConditions?: VisibilityConditionGroup | null;
    /**
     * List of triggers that can spawn template sections when conditions are met
     * @type {Array<SectionSpawnTriggerDto>}
     * @memberof FormElementDto
     */
    sectionSpawnTriggers?: Array<SectionSpawnTriggerDto>;
    /**
     * If true, user can add more instances of this element
     * @type {boolean}
     * @memberof FormElementDto
     */
    isClonable?: boolean;
    /**
     * If true, the field must be filled before submission
     * @type {boolean}
     * @memberof FormElementDto
     */
    isRequired?: boolean;
    /**
     * If false, the element is excluded from PDF export
     * @type {boolean}
     * @memberof FormElementDto
     */
    isVisibleInDocumentExport?: boolean;
    /**
     * Ordered list of row-preset variants. The first variant whose sourceTableReference resolves to a visible table element is applied; later variants are the documented fallback for alternate form paths.
     * @type {Array<TableRowPresetDto>}
     * @memberof FormElementDto
     */
    crossTableDerivedRows?: Array<TableRowPresetDto>;
}



/**
 * Check if a given object implements the FormElementDto interface.
 */
export function instanceOfFormElementDto(value: object): value is FormElementDto {
    if (!('options' in value) || value['options'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function FormElementDtoFromJSON(json: any): FormElementDto {
    return FormElementDtoFromJSONTyped(json, false);
}

export function FormElementDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormElementDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'reference': json['reference'] == null ? undefined : json['reference'],
        'title': json['title'] == null ? undefined : json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'statement': json['statement'] == null ? undefined : json['statement'],
        'clarification': json['clarification'] == null ? undefined : json['clarification'],
        'options': ((json['options'] as Array<any>).map(FormOptionDtoFromJSON)),
        'type': FormElementTypeFromJSON(json['type']),
        'formElementSubSectionId': json['formElementSubSectionId'] == null ? undefined : json['formElementSubSectionId'],
        'visibilityConditions': json['visibilityConditions'] == null ? undefined : VisibilityConditionGroupFromJSON(json['visibilityConditions']),
        'sectionSpawnTriggers': json['sectionSpawnTriggers'] == null ? undefined : ((json['sectionSpawnTriggers'] as Array<any>).map(SectionSpawnTriggerDtoFromJSON)),
        'isClonable': json['isClonable'] == null ? undefined : json['isClonable'],
        'isRequired': json['isRequired'] == null ? undefined : json['isRequired'],
        'isVisibleInDocumentExport': json['isVisibleInDocumentExport'] == null ? undefined : json['isVisibleInDocumentExport'],
        'crossTableDerivedRows': json['crossTableDerivedRows'] == null ? undefined : ((json['crossTableDerivedRows'] as Array<any>).map(TableRowPresetDtoFromJSON)),
    };
}

export function FormElementDtoToJSON(json: any): FormElementDto {
    return FormElementDtoToJSONTyped(json, false);
}

export function FormElementDtoToJSONTyped(value?: FormElementDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'reference': value['reference'],
        'title': value['title'],
        'description': value['description'],
        'statement': value['statement'],
        'clarification': value['clarification'],
        'options': ((value['options'] as Array<any>).map(FormOptionDtoToJSON)),
        'type': FormElementTypeToJSON(value['type']),
        'formElementSubSectionId': value['formElementSubSectionId'],
        'visibilityConditions': VisibilityConditionGroupToJSON(value['visibilityConditions']),
        'sectionSpawnTriggers': value['sectionSpawnTriggers'] == null ? undefined : ((value['sectionSpawnTriggers'] as Array<any>).map(SectionSpawnTriggerDtoToJSON)),
        'isClonable': value['isClonable'],
        'isRequired': value['isRequired'],
        'isVisibleInDocumentExport': value['isVisibleInDocumentExport'],
        'crossTableDerivedRows': value['crossTableDerivedRows'] == null ? undefined : ((value['crossTableDerivedRows'] as Array<any>).map(TableRowPresetDtoToJSON)),
    };
}

